const VolSurfacePageLayout = (props) => {
    return (
        <>
            {props.children}
        </>
    )
  };
  
  export default VolSurfacePageLayout;